import {MailTemplate} from '@models/adminstration/organization/mail/mail-template';

export class MailSettings {
  id: number;
  parentTenant: number;
  welcomeMail: MailTemplate;
  resetPasswordMail: MailTemplate;
  changePasswordMail: MailTemplate;


  constructor() {
    this.id = -1;
    this.parentTenant = -1;
    this.welcomeMail = new MailTemplate();
    this.resetPasswordMail = new MailTemplate();
    this.changePasswordMail = new MailTemplate();
  }
}
